module.exports = __webpack_public_path__ + "img/nzavo-recipes.5d745dbb.webp";